import { render, staticRenderFns } from "./prd-preview.vue?vue&type=template&id=ba8b0abc&scoped=true"
import script from "./prd-preview.vue?vue&type=script&lang=js"
export * from "./prd-preview.vue?vue&type=script&lang=js"
import style0 from "./prd-preview.vue?vue&type=style&index=0&id=ba8b0abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b0abc",
  null
  
)

export default component.exports